export default class AbsolutePositioning {
  constructor(element) {
    let targetSelector = element;
    let relativeElement = element.getAttribute("data-relative-element");
    relativeElement = document.getElementsByClassName(relativeElement)[0];
    let styleProperty = element.getAttribute("data-style");

    // If viewed in Drupal admin
    let toolbarHeight = 0;
    if (document.getElementsByClassName("toolbar-fixed")[0]) {
      toolbarHeight = document.getElementsByClassName("toolbar-fixed")[0]
        .offsetHeight;
    }

    let setPosition = function () {
      let distanceTop = relativeElement.offsetHeight + toolbarHeight + "px";
      targetSelector.style.top = distanceTop;
    };

    window.addEventListener("load", setPosition);
    window.addEventListener("resize", setPosition);
  }
}
